module.exports = __webpack_public_path__ + "static/media/body-bg-modal.a43535d8.png";